import type { Project } from '@finsim/model';
import { createEvent, createStore, sample } from 'effector';
import { saveProjectFx } from '../../entities/library';
import { routes } from '../../shared/routing';

/** A newly built project is saved locally first, then opened. */
export const projectCreated = createEvent<Project>();

const $pendingId = createStore<string | null>(null).on(projectCreated, (_, p) => p.id);

sample({ clock: projectCreated, target: saveProjectFx });
sample({
  clock: saveProjectFx.done,
  source: $pendingId,
  filter: (pending, { params }) => pending === params.id,
  fn: (_, { params }) => ({ projectId: params.id }),
  target: routes.project.open,
});
sample({ clock: routes.project.opened, fn: () => null, target: $pendingId });
